import type { CSSProperties } from "react";
import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <img
    className="ExcalidrawLogo-icon"
    src="/om-logo.png"
    alt="O+M logo"
    loading="lazy"
  />
);

const LogoText = () => (
  <div className="ExcalidrawLogo-text" aria-hidden="true">
    <span className="word">Croqui</span>
    <span className="accent">O+M</span>
  </div>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <div className="ExcalidrawLogo-badge">
        <LogoIcon />
      </div>
      {withText && <LogoText />}
    </div>
  );
};
